import { listen } from 'quicklink';

import waitForDom from 'src/utils/waitForDom';
import footer from './footer';
import wrapLink from './wrapLink';
import lazyload from './lazyload';
import checkIfHeadless from 'src/utils/checkIfHeadless';
import inView from 'src/utils/inView';

const gitBranch = process.env.GIT_BRANCH || 'unknown';
const gitCommit = process.env.GIT_COMMIT || 'unknown';
const buildDate = process.env.BUILD_DATE || 'unknown';

waitForDom(() => {
  if (!checkIfHeadless()) {
    document.head.insertAdjacentHTML(
      'afterbegin',
      `<meta name="build-date" content="${buildDate}"><meta name="build-branch" content="${gitBranch}"><meta name="build-commit" content="${gitCommit}">`,
    );
  }

  import('@iconify/iconify');
  footer();
  inView({
    selector: '[data-site-footer]',
    threshold: 0.35,
    rootMargin: '0px',
  });
  lazyload();
  wrapLink();
  listen();
});
